<!--头部title-->
<template>
  <div class="panel-header">
    <h3 class="panel-header__title">{{title}}</h3>
    <span class="panel-header__subtitle">{{subtitle}}</span>
    <slot name="customTag" ></slot>
    <a class="panel-header__export" v-if="exportUrl" :href="exportUrl">导出</a>
  </div>
</template>

<script>
export default {
  name: 'PanelHead',
  props: {
    title: {
      type: String,
      required: true
    },
    subtitle: {
      type: String,
      required: true
    },
    exportUrl: String
  }
};
</script>

<style lang="scss" type="text/scss">
@include b(panel-header) {
  position: relative;
  color: #566874;
  padding-bottom: 30px;
  @include e(title) {
    height: 24px;
    margin-bottom: 6px;
    font-size: 24px;
    line-height: 24px;
  }

  @include e(subtitle) {
    height: 12px;
    font-size: 12px;
    line-height: 12px;
  }

  @include e(export) {
    position: absolute;
    top: 9px;
    right: 0;
    width: 58px;
    height: 22px;
    font-size: 13px;
    line-height: 22px;
    text-align: center;
    border: 1px solid #1d2b36;
    background: #edf1f2;
    border-radius: 3px 3px;
    cursor: pointer;

    &:hover {
      background: #fff;
    }
  }
}
</style>
